// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body_block {\r\n    /*background: url(\"/src/static/images/02M0gPq.jpg\");*/\r\n    background: black;\r\n    font-family: Roboto, serif;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
